import { css } from "@emotion/react";

export const appContentPadding = "1.75rem";
export const appHeaderHeight = "70px";
export const appFooterBarHeight = "60px";

/**
 * 한줄 텍스트 말줄임표
 * @description style 태그에 할당하여 사용
 *
 * @example <div style={ellipsis}>{text}</div>
 */
export const ellipsis: React.CSSProperties = {
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
};

/**
 * 여러줄 텍스트 말줄임표
 * @param line 표시할 줄 수
 * @description jsx 태그의 css prop에 할당하여 사용
 *
 * @example <div css={multiLineEllipsis(2)}>{text}</div>
 */
export const multiLineEllipsis = (line: number) => css`
  display: -webkit-box !important;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: ${line};
  -webkit-box-orient: vertical;
  word-break: break-all;
  flex: 1;
`;
